import { render } from "./TheLoaiHinhHanhNgheY.vue?vue&type=template&id=5c10b108"
import script from "./TheLoaiHinhHanhNgheY.vue?vue&type=script&lang=js"
export * from "./TheLoaiHinhHanhNgheY.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__